export default __webpack_public_path__ + "805bd0a8c8f8c747d78571c18619d324.png";